/**
 * Plan tablosu artık `@mentorivo/shared` içinde.
 *
 * Taşındı çünkü kayıt akışı abonelik satırını açarken aynı limitleri
 * kullanıyor (`Subscription.adSpendLimit` vb.). Tablo yalnızca burada
 * kalsaydı backend sayıları ikinci kez tanımlar, ikisi de "tek kaynak"
 * iddia eder ve er geç ayrışırdı.
 *
 * Bu dosya yeniden dışa aktarım olarak duruyor: `@/lib/plans`'tan okuyan
 * bileşenlerin (fiyat bölümü, harcama ölçeği) import satırını değiştirmeye
 * gerek yok. Yeni kod doğrudan `@mentorivo/shared`'dan da alabilir.
 */

export {
  ANNUAL_DISCOUNT,
  GRACE_DAYS,
  PLANS,
  TRIAL,
  annualMonthlyUsd,
  planAt,
  type Plan,
  type PlanId,
  type Quota,
} from '@mentorivo/shared';
